import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { Params, Router } from '@angular/router';
import { EntityKey } from '../entity/entity';
import { PersonLoginService } from '../services/person-login-service';
import { StringUtils } from '../utils/string-utils';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { RiserProjectDefaultsComponent } from './riser-project-defaults/riser-project-defaults.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { PersonLogin } from '../person/person-login';
import { EntityPerformanceDefaultsComponent } from './entity-performance-defaults/entity-performance-defaults.component';

@Component({
  selector: 'project-defaults',
  templateUrl: './project-defaults.component.html',
  styleUrls: ['./project-defaults.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon, FormsModule, RiserProjectDefaultsComponent, MatTab, MatTabGroup, EntityPerformanceDefaultsComponent],
})
export class ProjectDefaultsComponent implements OnChanges, OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly router = inject(Router);
  readonly entityId = input.required<string>({ alias: 'entity-id' });
  readonly entityName = input.required<string>({ alias: 'entity-name' });
  readonly entityRevision = input.required<string>({ alias: 'entity-revision' });
  readonly entityKey = signal<EntityKey>(undefined!);
  personLogin!: PersonLogin;
  readonly errorMessage = signal<string>(undefined!);

  ngOnInit(): void {
    this.initialize();
    this.personLogin = this.personLoginService.getCachedLogin()!;
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']).then(() => this.errorMessage.set(undefined!));
    }
  }

  private backToEntity(): void {
    let pageName: string = this.entityKey().entityName === 'QUOTE' ? 'quotes' : 'orders';
    this.router.navigate([pageName, this.entityKey().entityId, this.entityKey().entityRevision]).then(() => this.errorMessage.set(undefined!));
  }

  goBack(): void {
    if (this.entityKey() && this.entityKey().entityName) {
      this.backToEntity();
    } else {
      this.router.navigate(['main']).then(() => this.errorMessage.set(undefined!));
    }
  }

  handleError(error: any): void {
    if (error) {
      this.errorMessage.set(StringUtils.getErrorMessage(error));
    }
  }

  private initialize(): void {
    const entityName: string = this.entityName();
    const idString: string = this.entityId();
    const revisionString: string = this.entityRevision();
    if (StringUtils.isNotBlank(entityName) && StringUtils.isNotBlank(idString) && !StringUtils.isEmptyNumericValue(+revisionString)) {
      this.entityKey.set(new EntityKey());
      this.entityKey().entityId = idString;
      this.entityKey().entityName = entityName;
      this.entityKey().entityRevision = +revisionString;
    } else {
      this.goBack();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (Object.values(changes).some((change: SimpleChange) => !change.firstChange)) {
      this.initialize();
    }
  }
}
